module.exports = __webpack_public_path__ + "static/img/invoice.466cf74.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/invoice.png
// module id = Wt6C
// module chunks = 4